import { render, staticRenderFns } from "./LineItemRow.vue?vue&type=template&id=5f2bf25b&scoped=true&"
import script from "./LineItemRow.vue?vue&type=script&lang=ts&"
export * from "./LineItemRow.vue?vue&type=script&lang=ts&"
import style0 from "./LineItemRow.vue?vue&type=style&index=0&id=5f2bf25b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bf25b",
  null
  
)

export default component.exports